import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const IMPLEMENT_SELF_IMPROVEMENT_TASK: BuiltInTaskDefinition = {
    slug: 'implement-self-improvement',
    name: 'Implement an approved recommendation',
    kind: 'llm',
    overlapPolicy: 'os',
    concurrencySafe: false,
    serializeOn: null,
    builtInRole: 'implement',
    chatPurpose: null,
    goal: 'Apply one approved recommendation as a new task version without widening tools or dropping gates',
    metric: {
        text: 'Share of approved recommendations that land as a non-widening new version',
    },
    guardrails: [
        'Implement the approved recommendation only',
        'Do not add tools',
        'Do not drop gates',
        'Do not raise spend or model tier',
    ],
    inputs: [
        {
            key: 'recommendationId',
            label: 'Recommendation id',
            type: 'string',
            required: true,
        },
        {
            key: 'taskId',
            label: 'Source task id',
            type: 'string',
            required: true,
        },
    ],
    tools: [],
    gates: [],
    spend: {
        moneyUsdPerRun: 1,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [],
    skillMd: TASK_TEXT['implement-self-improvement.md'],
    adapterMd: TASK_TEXT['implement-self-improvement.adapter.md'],
}
